import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInformation: {
        id: 'ml.policychange.additionalPolicyInfo.Additional Information',
        defaultMessage: 'Additional Information',
    },
    additionalPolicyInfo: {
        id: 'ml.policychange.additionalPolicyInfo.Additional Policy Info',
        defaultMessage: 'Additional Policy Info'
    },
    additionalPolicyInformation: {
        id: 'ml.policychange.additionalPolicyInfo.Additional Policy Information',
        defaultMessage: 'Additional Policy Information',
    },
    reviewInformationPolicyInfo: {
        id: 'ml.policychange.additionalPolicyInfo.Review information',
        defaultMessage: 'Review this information and make changes as needed',
    },
    pleaseUpdateDueToPolChange: {
        id: 'ml.policychange.additionalPolicyInfo.Please update any questions which may have changed due to this policy change',
        defaultMessage: 'Please update any questions which may have changed due to this policy change'
    },
    driverError: {
        id: 'ml.policychange.additionalPolicyInfo.Driver Error',
        defaultMessage: 'Excluded Drivers or household members marked with (!) need your attention'
    },
    houseAdditionalInformation: {
        id: 'ml.policychange.additionalPolicyInfo.HouseAdditionalInformation',
        defaultMessage: 'Additional Information'
    },
    Reminder: {
        id: 'ml.policychange.additionalPolicyInfo.Reminder',
        defaultMessage: '<strong>Reminder</strong>'
    },
    existingChangeAlert: {
        id: 'ml.policychange.additionalPolicyInfo.existingChangeAlert',
        defaultMessage: '{msg1} <p></p> {msg2}',
    },
    PleaseUpdate: {
        id: 'ml.policychange.additionalPolicyInfo.Please update',
        defaultMessage: 'Please update any questions which may have changed'
    },
    weWillReviewYourQuoteNext: {
        id: 'ml.policychange.additionalPolicyInfo.We\'ll review your quote next',
        defaultMessage: 'We\'ll {reviewYourQuote} next'
    },
    reviewYourQuote: {
        id: 'ml.policychange.additionalPolicyInfo.review your quote',
        defaultMessage: 'review your quote'
    },
    vehiclePercentageDriverError: {
        id: 'ml.policychange.additionalPolicyInfo.One or more drivers have not been assigned as the highest percentage on a vehicle',
        defaultMessage: 'One or more drivers have not been assigned as the highest percentage on a vehicle'
    },
    vehiclePrimaryDriverError: {
        id: 'ml.policychange.additionalPolicyInfo.One or more drivers have not been assigned as a principal driver on a vehicle',
        defaultMessage: 'One or more drivers have not been assigned as a principal driver on a vehicle'
    },
    totalPercentageError: {
        id: 'ml.policychange.additionalPolicyInfo.Total for each vehicle must equal 100',
        defaultMessage: 'Total for each vehicle must equal 100'
    },
    assignmentRequiredError: {
        id: 'ml.policychange.additionalPolicyInfo.One or more vehicles have not been assigned with a principal driver',
        defaultMessage: 'One or more vehicles have not been assigned with a principal driver'
    },
    driverVehicleError: {
        id: 'ml.policychange.additionalPolicyInfo.All drivers who have completed the Accident Prevention Course must have a Primary vehicle selected.',
        defaultMessage: 'All drivers who have completed the Accident Prevention Course must have a Primary vehicle selected.'
    },
    reviewIdentifiedFields: {
        id: 'ml.policychange.pages.additionalPolicyInfo.hvq.Review the below identified fields',
        defaultMessage: 'Review the below identified fields'
    },
    verifyPrefilledInfo: {
        id: 'ml.policychange.pages.additionalPolicyInfo.hvq.Verify the information we prefilled for you',
        defaultMessage: 'Verify the information we prefilled for you'
    },
    showAnimalSpecificMessage: {
        id: 'ml.policychange.pages.additionalPolicyInfo.Please select at least one animal type or update animal question to No.',
        defaultMessage: 'Please select at least one animal type or update animal question to No.'
    },
    nextLabel: {
        id: 'ml.policychange.pages.additionalPolicyInfo.nextLabel.We\'ll check if additional changes are needed next',
        defaultMessage: 'We\'ll check if {additionalChangesAreNeeded} next'
    },
    additionalChangesAreNeeded: {
        id: 'ml.policychange.pages.additionalPolicyInfo.nextLabel.additional changes are needed',
        defaultMessage: 'additional changes are needed'
    },
    makeChanges: {
        id: 'ml.policychange.additionalPolicyInfo.makeChanges',
        defaultMessage: 'Make Changes'
    },
    updatedAddtlPolicyInfo: {
        id: 'ml.policychange.additionalPolicyInfo.Updated Additional Policy Info',
        defaultMessage: 'Updated Additional Policy Info'
    },
    verifyAdditionalDetails: {
        id: 'ml.policychange.additionalPolicyInfo.Verify Additional Details',
        defaultMessage: 'Verify Additional Details'
    },
    animalExclusionWarningMessage: {
        id: 'ml.policychange.additionalPolicyInfo.animalExclusionWarningMessage',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.'
    },
    invalidLandlordOfferingErrorTitle: {
        id: 'ml.policychange.additionalPolicyInfo.Invalid Occupancy Selection',
        defaultMessage: 'Invalid Occupancy Selection'
    },
    invalidLandlordOffering: {
        id: 'ml.policychange.additionalPolicyInfo.Landlord Condo policies are supported only with Value Plus offering',
        defaultMessage: 'Landlord Condo policies are only available under the Value Plus offering. To proceed, please either change the occupancy to “Myself” or rewrite to a new Landlord policy with the Value Plus offering.'
    },
    animalLiabilityExclusion: {
        id: 'ml.policychange.additionalPolicyInfo.animalLiabilityExclusion',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy'
    },
    vacantDwellingUWWarning: {
        id: 'ml.policychange.additionalPolicyInfo.vacantDwellingUWWarning',
        defaultMessage: 'Vacant dwellings are ineligible for coverage under this product. However, coverage may be available under our Landlord product.'
    },
    vacantDwellingUWWarningLandlordCondo: {
        id: 'ml.policychange.additionalPolicyInfo.vacantDwellingUWWarningLandlordCondo',
        defaultMessage: 'Platinum Package is not available when Occupancy is Vacant. Offering has been updated to Landlord Condo (Comprehensive).'
    }, 
    vacantDwellingUWWarningLandlordHome: {
        id: 'ml.policychange.additionalPolicyInfo.vacantDwellingUWWarningLandlordHome',
        defaultMessage: 'Platinum Package is not available when Occupancy is Vacant. Offering has been updated to Dwelling Fire Three (Comprehensive).'
    },
    tenantOccupied: {
        id: 'ml.policychange.additionalPolicyInfo.tenantOccupied',
        defaultMessage: 'Tenant occupied'
    },
    dayCareNotification: {
        id: 'ml.policychange.additionalPolicyInfo.dayCareNotification',
        defaultMessage: 'We will require the submission to have childcare coverage'
    },
});
